import { render, staticRenderFns } from "./GuilderHeadButton.vue?vue&type=template&id=22e04f5a&scoped=true&"
import script from "./GuilderHeadButton.vue?vue&type=script&lang=ts&"
export * from "./GuilderHeadButton.vue?vue&type=script&lang=ts&"
import style0 from "./GuilderHeadButton.vue?vue&type=style&index=0&id=22e04f5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e04f5a",
  null
  
)

export default component.exports